export const CELL_WIDTH = 140;
export const CELL_HEIGHT = 100;
export const CELL_PADDING = 20;

export const ICON_WIDTH = 60;
export const ICON_HEIGHT = 60;

export const ANCHOR_WRAPPER = CELL_PADDING;

// Grid used for snapping free-form elements (groups, textareas, info blocks)
export const GRID_SIZE = 10;

export const DIAGRAM_SIDEBAR_WIDTH_MIN = 400;
export const DIAGRAM_SIDEBAR_WIDTH = 450;
export const DIAGRAM_SIDEBAR_NAV_WIDTH = 50;

export const DIAGRAM_DEFAULT_COLUMNS = 24;
export const DIAGRAM_DEFAULT_ROWS = 16;

export const DIAGRAM_MIN_ROWS = 3;
export const DIAGRAM_MIN_COLUMNS = 4;

export const DIAGRAM_MAX_ROWS = 128;
export const DIAGRAM_MAX_COLUMNS = 128;

export const DIAGRAM_PADDING = 480;
export const DIAGRAM_EDGE_SIZE = 24;

export const printWidth = (columns: number, coordinates: boolean) =>
    columns * CELL_WIDTH + (coordinates ? DIAGRAM_EDGE_SIZE * 2 : 0);
export const printHeight = (rows: number, coordinates: boolean) =>
    rows * CELL_HEIGHT + (coordinates ? DIAGRAM_EDGE_SIZE * 2 : 0);

export const diagramWidth = (columns: number) => columns * CELL_WIDTH + DIAGRAM_PADDING * 2;
export const diagramHeight = (rows: number) => rows * CELL_HEIGHT + DIAGRAM_PADDING * 2;

export const HEADER_HEIGHT = 60;

export const SCALE_STEPS = [0.1, 0.25, 0.5, 0.65, 0.9, 1, 1.25, 1.7, 2.0];

export const SCALE_MIN = SCALE_STEPS[0];
export const SCALE_MAX = SCALE_STEPS[SCALE_STEPS.length - 1];

export const Z_INDEX = {
    HEADER: 100,
    SIDEBAR: 100,
    CONTROLS: 100,
    SELECTBOX: 80,
    START_FROM: 70,
    CANVAS: {
        ROOT: 70,

        POPOVER: 89,
        PASTE_SURFACE: 88,
        COMMENT: 90,
        ZONE: 84,

        IMAGE_PREVIEW: 87,

        ANCHORS: 86,

        CONNECTIONS: 85,

        LABELS: 84,
        LABELS_HOVER: 86,

        COMPONENT_DRAGGING: 92,
        COMPONENT_DEFAULT: 84,

        GRID: 60,
    },
    MESSAGE: 89,
    RESIZEABLE_ELEMENT: 996,
    COMMENT_BUTTON: 998,
    COMMENT_DIALOG: 999,
};
